import get from 'lodash/get';
import * as types from './constants';
const defaultState = {
  loading: false,
  error: null,
  application: {},
  breakdown: {},
  documents: [],
  settlement: [],
  sessionStartTime: '',
  property: [],
  selectedProperties: [],
  multipleProperties: {
    properties: [],
    totalPages: 1,
  },
  applicationId: null,
  applicationType: '',
  description: '',
  disputeDetail: {},
  manualAddresses: [],
  manualProperties: [],
  plaintiffTypeData: {},
  defendantTypeData: {},
  plaintiffList: [],
  defendantList: [],
  plaintiffs: [],
  defendants: [],
  demands: [],
  plotIds: [],
  disputedProperties: [],
  totalDemandValue: null,
  disputeLawFirmsPlaintiff: [],
  disputeLawFirmDefendant: [],
  lawFirmInfoFields: {},
  fetchedUser: {},
  selectedCase: null,
  casesData: {
    cases: [],
    totalPages: 1,
  },
  searchField: null,
};

export default function RequestExecutionStampReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.REQUEST_EXECUTION_STAMP_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.REQUEST_EXECUTION_STAMP_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.REQUEST_EXECUTION_STAMP_LOADING_IN_MODAL:
      return {
        ...state,
        loading: false,
        loadingInModal: true,
        error: null,
      };

    case types.CLEAR_REQUEST_EXECUTION_STAMP_APPLICATION_ERROR:
      return {
        ...state,
        error: null,
      };

    case types.FETCH_APPLICATION_REQUEST_EXECUTION_STAMP_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        contractDetails: get(action.payload, 'contractDetails', {}),
        disputeDetail: get(action.payload, 'disputeDetail', {}),
        disputeLawFirmsPlaintiff: get(action.payload, 'disputeLawFirmsPlaintiff', []),
        disputeLawFirmDefendant: get(action.payload, 'disputeLawFirmDefendant', []),
        plaintiffs: get(action.payload, 'plaintiffs', []),
        defendants: get(action.payload, 'defendants', []),
        plotIds: action?.payload?.application?.disputeProperties?.plotIds || [],
        disputedProperties: action?.payload?.application?.disputeProperties?.properties || [],
        manualProperties: action?.payload?.application?.disputeProperties?.manualProperties,
        demands: get(action.payload, 'demands', []),
        description: get(action.payload, 'description', []),
        settlement: get(action.payload, 'settlement', []),
        sessionStartTime: get(action.payload, 'sessionStartTime', []),
        fetchedUser: {},
      };
    case types.FETCH_PROPERTY_REQUEST_EXECUTION_STAMP_SUCCESS:
      return {
        ...state,
        loading: false,
        property: get(action.payload, 'property', {}),
      };
    case types.UPDATE_DEMANDS_DATA:
      return {
        ...state,
        loading: false,
        demands: get(action.payload, 'demands', []),
      };

    case types.FETCH_DOCUMENTS_REQUEST_EXECUTION_STAMP_SUCCESS:
      return {
        ...state,
        loading: false,
        documents: get(action.payload, 'documents', []),
      };

    case types.INITIATE_REQUEST_EXECUTION_STAMP_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        contractDetails: get(action.payload, 'contractDetails', {}),
      };

    case types.DOWNLOAD_DOCUMENT_REQUEST_EXECUTION_STAMP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.REQUEST_EXECUTION_STAMP_CANCEL_APPLICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }

    case types.REQUEST_EXECUTION_STAMP_CLEAR_DATA:
      return defaultState;

    case types.DOWNLOAD_TRANSFEER_REQUEST_EXECUTION_STAMP_CONTRACT_DOCUMENT_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.DOWNLOAD_REQUEST_EXECUTION_STAMP_CONTRACT_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.UPLOAD_REQUEST_EXECUTION_STAMP_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };

    case types.FETCH_REQUEST_EXECUTION_STAMP_PROPERTY_CONTRACT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        PropertyContractDetails: action.payload,
      };

    case types.FETCH_PLAINTIFF_SUCCESS:
      return {
        ...state,
        loading: false,
        plaintiffList: get(action.payload, 'plaintiffList', []),
      };
    case types.FETCH_DEFENDANT_SUCCESS:
      return {
        ...state,
        loading: false,
        defendantList: get(action.payload, 'defendantList', []),
      };

    case types.ADD_TO_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.GET_MULTIPLE_PROPERTIES:
      return {
        ...state,
        multipleProperties: {
          ...action.payload,
        },
        loading: false,
      };
    case types.SELECT_CASE:
      return {
        ...state,
        selectedCase: action.payload,
      };
    case types.EXECUTION_STAMP_PAYMENT_BREAKDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        breakdown: get(action.payload, 'breakdown', {}),
      };
    case types.FETCH_CASES_REQUEST_EXECUTION_STAMP_SUCCESS:
      return {
        ...state,
        loading: false,
        casesData: {
          cases: get(action.payload, 'cases', []),
          totalPages: get(action.payload, 'totalPages', 0),
        },
      };

    default:
      return state;
  }
}
